// src/pages/FeedbackPage.tsx
import React from 'react';
import '../Styles/FeedbackPage.css';

const FeedbackPage: React.FC = () => {
  return (
    <div className="feedback-container">
      <div className="feedback-card">
        <h1>Share Your Feedback</h1>
        <p>Your insights help us improve DigiRay for everyone.</p>
        
        <form className="feedback-form">
          <div className="form-group">
            <label>Rate Your Experience</label>
            <div className="rating-stars">
              {[...Array(5)].map((_, i) => (
                <span key={i} className="star">★</span>
              ))}
            </div>
          </div>
          
          <div className="form-group">
            <label>What kind of feedback is this?</label>
            <select>
              <option>Select a category</option>
              <option>Bug Report</option>
              <option>Feature Request</option>
              <option>General Feedback</option>
            </select>
          </div>
          
          <div className="form-group">
            <label>Tell us more about your experience</label>
            <textarea 
              placeholder="Describe your feedback here..." 
              rows={4}
            ></textarea>
          </div>
          
          <div className="form-group">
            <label>Any suggestions for improvement?</label>
            <textarea 
              placeholder="What features would you like to see? How can we do better?" 
              rows={4}
            ></textarea>
          </div>
          
          <div className="form-actions">
            <button className="back-btn">Back</button>
            <button type="submit" className="submit-btn">Submit Feedback</button>
          </div>
        </form>
      </div>
    </div>
  );
};


export default FeedbackPage;